import { DayLabel } from '@shared/components'

import { Button, Col, Flex, Modal, Row, Space, Typography } from 'antd'

import { Eye } from 'iconsax-react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ActivityLogAvatar } from './ActivityLogAvatar'
import { useStyles } from './styles'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

const { Paragraph } = Typography

export const ActivityLogEmail = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()

  const { styles } = useStyles()
  const translatedDescription = useGetTranslatedDescription({ log })

  const [showMore, setShowMore] = useState(false)
  const [fullDescriptionModal, setFullDescriptionModal] = useState(false)

  const onExpand = () => setShowMore((prevState) => !prevState)
  const onToggleFullDescriptionModal = () =>
    setFullDescriptionModal((prevState) => !prevState)

  return (
    <Row justify="space-between" gutter={[16, 16]}>
      <Col xs={24} xl={15} xxl={18}>
        <Paragraph
          ellipsis={{
            expandable: true,
            expanded: showMore,
            rows: 2,
            onExpand
          }}
        >
          {translatedDescription}
        </Paragraph>
      </Col>

      <Col xs={24} xl={9} xxl={6}>
        <Flex gap={8} justify="end" align="center" className="h-full">
          <ActivityLogAvatar
            user={log?.created_by}
            label={t('task.created_by')}
          />

          <DayLabel date={log.created_at} />

          <Space.Compact>
            <Button
              size="small"
              onClick={onToggleFullDescriptionModal}
              icon={<Eye size={16} />}
            />
          </Space.Compact>
        </Flex>
      </Col>

      <Modal
        width={800}
        title={t('contacts.full_description')}
        open={fullDescriptionModal}
        className={styles.modal}
        okText={t('buttons.close')}
        onCancel={onToggleFullDescriptionModal}
      >
        <div
          dangerouslySetInnerHTML={{ __html: log?.full_description || '' }}
        />
      </Modal>
    </Row>
  )
}
